import React from "react";
import Letop from "../allpages/Letop";

export default () => (
  <div>
    <div className="table">
      <table>
        <tr>
          <th className="col bor-bot" />
          <th>mannelijk</th>
          <th>vrouwelijk</th>
          <th>onzijdig</th>
        </tr>
        <tr>
          <th className="col">nom. ev.</th>
          <td>hic</td>
          <td>haec</td>
          <td>hoc</td>
        </tr>
        <tr>
          <th className="col">gen. ev.</th>
          <td>huius</td>
          <td>huius</td>
          <td>huius</td>
        </tr>
        <tr>
          <th className="col">dat. ev.</th>
          <td>huic</td>
          <td>huic</td>
          <td>huic</td>
        </tr>
        <tr>
          <th className="col">acc. ev.</th>

          <td>hunc</td>
          <td>hanc</td>
          <td>hoc</td>
        </tr>
        <tr>
          <th className="col bor-bot">abl. ev.</th>
          <td className="bor-bot">hoc</td>
          <td className="bor-bot">hac</td>
          <td className="bor-bot">hoc</td>
        </tr>
        <tr>
          <th className="col">nom. mv.</th>
          <td>hi</td>
          <td>hae</td>
          <td>haec</td>
        </tr>
        <tr>
          <th className="col">gen. mv.</th>
          <td>horum</td>
          <td>harum</td>
          <td>horum</td>
        </tr>
        <tr>
          <th className="col">dat. mv.</th>
          <td>his</td>
          <td>his</td>
          <td>his</td>
        </tr>
        <tr>
          <th className="col">acc. mv.</th>
          <td>hos</td>
          <td>has</td>
          <td>haec</td>
        </tr>
        <tr>
          <th className="col bor-bot">abl. mv.</th>
          <td className="bor-bot">his</td>
          <td>his</td>
          <td className="bor-bot">his</td>
        </tr>
        <tr>
          <th className="col" />
          <td colSpan={3} className="center">
            <i>1. deze, dit &nbsp;&nbsp;&nbsp; 2. hij, zij, het</i>
          </td>
        </tr>
      </table>
    </div>

    <div className="table">
      <table>
        <tr>
          <th className="col bor-bot" />
          <th>mannelijk</th>
          <th>vrouwelijk</th>
          <th>onzijdig</th>
        </tr>
        <tr>
          <th className="col">nom. ev.</th>
          <td>ille</td>
          <td>illa</td>
          <td>illud</td>
        </tr>
        <tr>
          <th className="col">gen. ev.</th>
          <td>illius</td>
          <td>illius</td>
          <td>illius</td>
        </tr>
        <tr>
          <th className="col">dat. ev.</th>
          <td>illi</td>
          <td>illi</td>
          <td>illi</td>
        </tr>
        <tr>
          <th className="col">acc. ev.</th>

          <td>illum</td>
          <td>illam</td>
          <td>illud</td>
        </tr>
        <tr>
          <th className="col bor-bot">abl. ev.</th>
          <td className="bor-bot">illo</td>
          <td className="bor-bot">illa</td>
          <td className="bor-bot">illo</td>
        </tr>
        <tr>
          <th className="col">nom. mv.</th>
          <td>illi</td>
          <td>illae</td>
          <td>illa</td>
        </tr>
        <tr>
          <th className="col">gen. mv.</th>
          <td>illorum</td>
          <td>illarum</td>
          <td>illorum</td>
        </tr>
        <tr>
          <th className="col">dat. mv.</th>
          <td>illis</td>
          <td>illis</td>
          <td>illis</td>
        </tr>
        <tr>
          <th className="col">acc. mv.</th>
          <td>illos</td>
          <td>illas</td>
          <td>illa</td>
        </tr>
        <tr>
          <th className="col bor-bot">abl. mv.</th>
          <td className="bor-bot">illis</td>
          <td>illis</td>
          <td className="bor-bot">illis</td>
        </tr>
        <tr>
          <th className="col" />
          <td colSpan={3} className="center">
            <i>1. die, dat &nbsp;&nbsp;&nbsp; 2. hij, zij, het</i>
          </td>
        </tr>
      </table>
    </div>

    <div className="table">
      <table>
        <tr>
          <th className="col bor-bot" />
          <th>mannelijk</th>
          <th>vrouwelijk</th>
          <th>onzijdig</th>
        </tr>
        <tr>
          <th className="col">nom. ev.</th>
          <td>iste</td>
          <td>ista</td>
          <td>istud</td>
        </tr>
        <tr>
          <th className="col">gen. ev.</th>
          <td>istius</td>
          <td>istius</td>
          <td>istius</td>
        </tr>
        <tr>
          <th className="col">dat. ev.</th>
          <td>isti</td>
          <td>isti</td>
          <td>isti</td>
        </tr>
        <tr>
          <th className="col">acc. ev.</th>

          <td>istum</td>
          <td>istam</td>
          <td>istud</td>
        </tr>
        <tr>
          <th className="col bor-bot">abl. ev.</th>
          <td className="bor-bot">isto</td>
          <td className="bor-bot">ista</td>
          <td className="bor-bot">isto</td>
        </tr>
        <tr>
          <th className="col">nom. mv.</th>
          <td>isti</td>
          <td>istae</td>
          <td>ista</td>
        </tr>
        <tr>
          <th className="col">gen. mv.</th>
          <td>istorum</td>
          <td>istarum</td>
          <td>istorum</td>
        </tr>
        <tr>
          <th className="col">dat. mv.</th>
          <td>istis</td>
          <td>istis</td>
          <td>istis</td>
        </tr>
        <tr>
          <th className="col">acc. mv.</th>
          <td>istos</td>
          <td>istas</td>
          <td>ista</td>
        </tr>
        <tr>
          <th className="col bor-bot">abl. mv.</th>
          <td className="bor-bot">istis</td>
          <td>istis</td>
          <td className="bor-bot">istis</td>
        </tr>
        <tr>
          <th className="col" />
          <td colSpan={3} className="center">
            <i>1. die, dat &nbsp;&nbsp;&nbsp; 2. hij, zij, het</i>
          </td>
        </tr>
      </table>
    </div>

    <p>
      <Letop>
        Deze rijtjes lijken erg op het rijtje van{" "}
        <a href="bijvoeglijk-naamwoord">
          <b>longus</b>
        </a>
        . Alleen de nominativus, genitivus en dativus enkelvoud wijken af.
      </Letop>
    </p>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/tables/aanw-vnw.js